<template>
  <div>
    <b-card
      no-body
    >
      <b-tabs
        ref="statusSettingTabBar"
        pills
      >
        <b-tab
          v-if="store.getters.permissions.filter(permission => permission === 'edit-finance-status-setting').length > 0"
        >
          <template #title>
            <span>Finance Statuses</span>
          </template>
          <hr>
          <status-form type="Finance" />
        </b-tab>
        <b-tab
          v-if="store.getters.permissions.filter(permission => permission === 'edit-quick-status-update').length > 0"
        >
          <template #title>
            <span>Quick Status Update</span>
          </template>
          <b-form
            @submit.prevent
            @submit="setStatusSetting"
          >
            <b-row>
              <b-card
                title="Quick Status Update for Single Order"
              >
                <b-form-radio-group
                  v-model="isQuickStatusUpdateEnabled"
                  :options="radioOptions"
                  class="demo-inline-spacing"
                  value-field="value"
                  text-field="text"
                  disabled-field="disabled"
                />
              </b-card>
            </b-row>
            <b-row>
              <div class="ml-2">
                If this mode is on, it allows you to update an order to the next status directly from the order details window.
              </div>
            </b-row>
            <b-row>
              <!-- submit -->
              <b-col class="d-flex justify-content-end">
                <b-button
                  v-can="'edit-merchant-setting'"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  class="mt-1 custom-button-color"
                >
                  Submit
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BCol,
  BButton,
  BRow,
  BFormRadioGroup,
} from 'bootstrap-vue'
import StatusForm from '@/components/setting/statuses/StatusForm.vue'
import store from '@/store'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const StatusSettingsRepository = RepositoryFactory.get('statusSetting')

export default {
  components: {
    StatusForm,
    BCard,
    BForm,
    BCol,
    BButton,
    BRow,
    BFormRadioGroup,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      store,
      radioOptions: [
        { text: 'On', value: true },
        { text: 'Off', value: false },
      ],
      isQuickStatusUpdateEnabled: false,
    }
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.__preserveTabOnRefresh('statusSettingTabBar', 'statusSettingTabIndex')
    this.readStatusSetting()
  },
  methods: {
    async readStatusSetting() {
      this.loading = true
      try {
        const { data } = (await StatusSettingsRepository.getStatusSettings()).data
        this.isQuickStatusUpdateEnabled = data.quick_status_update.enabled
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async setStatusSetting() {
      this.loading = true
      try {
        const payload = {
          quick_status_update: {
            enabled: this.isQuickStatusUpdateEnabled,
          },
        }
        const res = await StatusSettingsRepository.updateStatusSettings(payload)
        if (res.status === 200) {
          this.showSuccessMessage('Quick Status Settings Updated Successfully')
        } else {
          this.showErrorMessage('Cannot Update Quick Status Settings')
        }
        // }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.readStatusSetting()
      this.loading = false
    },
  },
}
</script>
